import Select from "@/common/components/Select";
import TextField from "@/common/components/TextField";
import { Mapper } from "@/common/services/mapper";
import { CardDetailsData } from "@/common/types/cards/details.type";
import { Option } from "@/common/types/option";
import { ProductData } from "@/common/types/product.type";
import EquipmentInfo from "@/features/consumption/components/EquipmentInfo";

interface CardCurrentLimitEssentialInformationProps {
  cardIdentifier: string;
  setCardIdentifier: (value: string) => void;
  cardDetails?: CardDetailsData;
  cardDetailsIsError?: boolean;
  cardDetailsIsPending?: boolean;
  products: ProductData[]
  setProduct: (value: ProductData | undefined) => void;
  setSearchProduct?: (value: string) => void;
}

const CardCurrentLimitEssentialInformation = ({
  cardIdentifier,
  setCardIdentifier,
  cardDetails,
  cardDetailsIsError,
  cardDetailsIsPending,
  products,
  setProduct,
  setSearchProduct,
}: CardCurrentLimitEssentialInformationProps) => {
  return (
    <div className="flex flex-col gap-4 px-4 sm:gap-6 sm:p-0">
      <TextField
        label="Código do cartão ou Placa/N. de série do equipamento"
        onChange={(e: any) => setCardIdentifier(e.target.value)}
        markAsRequired
        errorMessage={cardDetailsIsError ? 'Cartão não encontrado' : ' '}
        isLoading={!!(cardIdentifier && cardDetailsIsPending)}
      />

      {cardDetails && (
        <EquipmentInfo cardDetails={cardDetails} />
      )}

      {!!cardDetails?.id && (
        <Select
          label="Produto para consulta"
          markAsRequired
          options={Mapper.mapToOptions<ProductData>({ valueFieldName: 'id', labelFieldName: 'display_name' })(products)}
          onChange={(e) => setProduct(products.find((p) => p.id === (e as Option).value))}
          onInputChange={setSearchProduct}
        />
      )}
    </div>
  );
}

export default CardCurrentLimitEssentialInformation;
